import { defaultFor } from "../registry";

export const OVERRIDES_STORAGE_KEY = "FEATURE_FLAG_OVERRIDES";

const overrides = () => {
  try {
    return JSON.parse(localStorage.getItem(OVERRIDES_STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

// Registry defaults plus localStorage overrides. No vendor client, no network.
export const createLocalChecker = () => (flagName) => {
  const value = overrides()[flagName];
  return typeof value === "boolean" ? value : defaultFor(flagName);
};
